import { connect } from 'react-redux';
import { feedbackActions } from '../../../actions/feedback';
import { FeedbackCard } from '../../../components/sidebar/cards';
const { feedbackRequest } = feedbackActions;
const mapDispatchToProps = (dispatch) => {
    return {
        requestFeedback: (payload) => dispatch(feedbackRequest(payload)),
    };
};
export default connect(null, mapDispatchToProps)(FeedbackCard);
